/**
 * Account Usage API
 * The signed-in user's own AI spend for today and this month.
 */
import { apiGet } from '@shared/services/api';

/** The enforcer's verdict for a period: what happens to the user's next call. */
export type BudgetStatus = 'proceed' | 'warn' | 'throttle' | 'reject';

/** Spend in one period; `limit` and `status` are null when the period has no limit. */
export interface PeriodSpend {
  spend: number;
  limit: number | null;
  status: BudgetStatus | null;
  resets_at: string;
}

/** Where the limits came from: the user's own budget, the default for all accounts, or none. */
export type BudgetSource = 'account' | 'default' | null;

export interface AccountUsage {
  today: PeriodSpend;
  month: PeriodSpend;
  budget_source: BudgetSource;
}

export const accountUsageApi = {
  /** Fetch the current user's spend and budget standing. */
  getUsage: (): Promise<AccountUsage> => apiGet<AccountUsage>('/api/account/usage'),
};
